import { SavedAudienceStandardTargetingSpec } from '../../facebook/audience';

export const leadFormAudienceMenuOptions = [
  'lead_generation_submitted',
  'lead_generation_dropoff',
  'lead_generation_opened',
] as const;
export type LeadFormAudienceMenuOption = typeof leadFormAudienceMenuOptions[number];

export interface LeadFormAudienceDTO {
  name: string;
  description?: string;
  isDefault: boolean;
  targetingSpec: SavedAudienceStandardTargetingSpec;
  retentionDays: number; // max 90
  leadFormIDs: string[];
  menuSelection: LeadFormAudienceMenuOption;
}
